/**
 * @deprecated
 */
export default function textInputComponent() {
  return {
    view: ({ attrs }) => {
      let errorClass = "";
      
      if (attrs.validate && !attrs.isvalid) {
        errorClass = "invalid-controller";
      }

      return m('.col',
        m(`label.form-label${attrs.mandatory ? '.mandatory' : ''}`, attrs.label),
        m('input',
          {
            value: attrs.value,
            class: "form-control form-control-bg " + errorClass,
            id: attrs.id,
            placeholder: attrs.placeholder,
            type: attrs.type ? attrs.type : "text",
            onchange: attrs.onchange ? attrs.onchange.bind(this) : null,
            onkeyup: attrs.onkeyup ? attrs.onkeyup.bind(this) : null,
            oninput: attrs.oninput ? attrs.oninput.bind(this) : null,
            autocomplete: (attrs.type == "password" ? "new-password" : null),
            required: attrs.mandatory ?? false,
            readonly: attrs.readonly ?? false,
            disabled: attrs.disabled ?? false
          },
        ),
        attrs.validate && !attrs.isvalid &&
        m(
          'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
          m('small', attrs.errorMessage)
        )
      );
    }
  }
}
